<template>
    <div>
        <div class="box">
            <p class="date_post">{{ date_post }}</p>
            <hr class="line">
            <h5 class="title_raport">{{ title }}</h5>
            <p class="raport_description" :title="description">{{ description }}.</p>
            <a class="moreButton" @click="redirectToPost(id)">Më shumë &nbsp; <font-awesome-icon
                    icon="fa-solid fa-arrow-right" /></a>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    props: ['date_post', 'description', 'buton', 'title', 'id'],

    methods: {
        redirectToPost(postId)
        {
            this.$router.push(`/report/${postId}`)
        }
    },
    mounted() {
        window.scrollTo(0, 0);
    },
}

</script>
<style scoped>
.box {
    position: relative;
    background-color: #FFFFFF;
    padding: 18px;
    border-radius: 12px;
    height:205px;

}

.date_post {
    font-size: 13px;
    color: #475467;
    line-height: 5px;
    letter-spacing: -1%;
    font-weight: 400;
}

.line {
    width: 100%;
    border: 1px solid #F1F5F9;
    margin:0;
}

.title_raport {
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0%;
    color: #101828;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* Kufizon në 4 rreshta */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    /* Shton pikat '...' vetëm nëse ka më shumë përmbajtje */
}

.raport_description {
    font-size: 15px;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: -0.2%;
    color: #475467;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.moreButton {
    position: absolute;
    font-size: 13px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0%;
    color: #2C3F5E;
    background-color: #FFFFFF;
    border: none;
    margin-top: 20px;
    bottom: 18px;
    padding: 0;
    text-decoration: none;
    cursor:pointer;
    margin-top:auto;
}

@media(max-width:1399px){
    .box{
        height:230px;
    }
}
</style>